import angular from 'angular';
import _ from 'underscore';

export default class BuyerAddresses {
  constructor($scope, GeoService) {
    $scope.tabs = ['Consignee', 'Notify Party', 'Address for Receiving Documents', 'Bank Details'];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.$watch('buyer.consignee_address.country_id', function() {
      if ($scope.buyer.consignee_address.country_id) {
        GeoService.get_cities($scope.buyer.consignee_address.country_id).then(function(data) {
          $scope.consignee_address_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.buyer.consignee_address.city_id}))
            $scope.buyer.consignee_address.city_id = null;
        });
      }
    });

    $scope.$watch('buyer.notify_address.country_id', function() {
      if ($scope.buyer.notify_address.country_id) {
        GeoService.get_cities($scope.buyer.notify_address.country_id).then(function(data) {
          $scope.notify_address_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.buyer.notify_address.city_id}))
            $scope.buyer.notify_address.city_id = null;
        });
      }
    });

    $scope.$watch('buyer.docs_address.country_id', function() {
      if ($scope.buyer.docs_address.country_id) {
        GeoService.get_cities($scope.buyer.docs_address.country_id).then(function(data) {
          $scope.docs_address_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.buyer.docs_address.city_id}))
            $scope.buyer.docs_address.city_id = null;
        });
      }
    });

    $scope.$watch('buyer.bank.country_id', function() {
      if ($scope.buyer.bank.country_id) {
        GeoService.get_cities($scope.buyer.bank.country_id).then(function(data) {
          $scope.bank_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.buyer.bank.city_id}))
            $scope.buyer.bank.city_id = null;
        });
      }
    });

    $scope.get_address = function() {
      return {
        company_title: null,
        vat: null,
        address_line_1: null,
        address_line_2: null,
        post_code: null,
        country_id: null,
        city_id: null,
        email: null,
        phone: null,
        fax: null
      };
    };

    $scope.get_docs_address = function() {
      return {
        contact_person: null,
        company_title: null,
        address_line_1: null,
        address_line_2: null,
        post_code: null,
        country_id: null,
        city_id: null,
        email: null,
        phone: null,
        fax: null
      };
    };

    $scope.get_bank = function() {
      return {
        title: null,
        branch: null,
        address_line_1: null,
        address_line_2: null,
        post_code: null,
        country_id: null,
        city_id: null,
        email: null,
        phone: null,
        fax: null,
        account_details: null,
        contact_person: null
      };
    };

    $scope.get_buyer_details = function() {
      return {
        consignee_address: $scope.get_address(),
        notify_address: $scope.get_address(),
        docs_address: $scope.get_docs_address(),
        bank: $scope.get_bank()
      };
    };

    $scope.clear_consignee_address = function() {
      $scope.buyer.consignee_address = $scope.get_address();
    };

    $scope.clear_notify_address = function() {
      $scope.buyer.notify_address = $scope.get_address();
    };

    $scope.clear_docs_address = function() {
      $scope.buyer.docs_address = $scope.get_docs_address();
    };

    $scope.clear_bank = function() {
      $scope.buyer.bank = $scope.get_bank();
    };

    $scope.autofill_consignee_address = function() {
      if (window.consignee_address) {
        $scope.buyer.consignee_address.company_title = window.consignee_address.company_title;
        $scope.buyer.consignee_address.vat = window.consignee_address.vat;
        $scope.buyer.consignee_address.address_line_1 = window.consignee_address.address_line_1;
        $scope.buyer.consignee_address.address_line_2 = window.consignee_address.address_line_2;
        $scope.buyer.consignee_address.post_code = window.consignee_address.post_code;
        $scope.buyer.consignee_address.country_id = window.consignee_address.country_id;
        $scope.buyer.consignee_address.city_id = window.consignee_address.city_id;
        $scope.buyer.consignee_address.email = window.consignee_address.email;
        $scope.buyer.consignee_address.phone = window.consignee_address.phone;
        $scope.buyer.consignee_address.fax = window.consignee_address.fax;
      } else {
        $scope.buyer.consignee_address = $scope.get_address();
      }
    };

    $scope.autofill_notify_address = function() {
      if (window.notify_address) {
        $scope.buyer.notify_address.company_title = window.notify_address.company_title;
        $scope.buyer.notify_address.vat = window.notify_address.vat;
        $scope.buyer.notify_address.address_line_1 = window.notify_address.address_line_1;
        $scope.buyer.notify_address.address_line_2 = window.notify_address.address_line_2;
        $scope.buyer.notify_address.post_code = window.notify_address.post_code;
        $scope.buyer.notify_address.country_id = window.notify_address.country_id;
        $scope.buyer.notify_address.city_id = window.notify_address.city_id;
        $scope.buyer.notify_address.email = window.notify_address.email;
        $scope.buyer.notify_address.phone = window.notify_address.phone;
        $scope.buyer.notify_address.fax = window.notify_address.fax;
      } else {
        $scope.buyer.notify_address = $scope.get_address();
      }
    };

    $scope.autofill_docs_address = function() {
      if (window.docs_address) {
        $scope.buyer.docs_address.contact_person = window.docs_address.contact_person;
        $scope.buyer.docs_address.company_title = window.docs_address.company_title;
        $scope.buyer.docs_address.address_line_1 = window.docs_address.address_line_1;
        $scope.buyer.docs_address.address_line_2 = window.docs_address.address_line_2;
        $scope.buyer.docs_address.post_code = window.docs_address.post_code;
        $scope.buyer.docs_address.country_id = window.docs_address.country_id;
        $scope.buyer.docs_address.city_id = window.docs_address.city_id;
        $scope.buyer.docs_address.email = window.docs_address.email;
        $scope.buyer.docs_address.phone = window.docs_address.phone;
        $scope.buyer.docs_address.fax = window.docs_address.fax;
      } else {
        $scope.buyer.docs_address = $scope.get_docs_address();
      }
    };

    $scope.autofill_bank = function() {
      if (window.trading_bank) {
        $scope.buyer.bank.title = window.trading_bank.title;
        $scope.buyer.bank.branch = window.trading_bank.branch;
        $scope.buyer.bank.address_line_1 = window.trading_bank.address_line_1;
        $scope.buyer.bank.address_line_2 = window.trading_bank.address_line_2;
        $scope.buyer.bank.post_code = window.trading_bank.post_code;
        $scope.buyer.bank.country_id = window.trading_bank.country_id;
        $scope.buyer.bank.city_id = window.trading_bank.city_id;
        $scope.buyer.bank.email = window.trading_bank.email;
        $scope.buyer.bank.phone = window.trading_bank.phone;
        $scope.buyer.bank.fax = window.trading_bank.fax;
        $scope.buyer.bank.account_details = window.trading_bank.account_details;
        $scope.buyer.bank.contact_person = window.trading_bank.contact_person;
      } else {
        $scope.buyer.bank = $scope.get_bank();
      }
    };

    $scope.selected_tab = 0;
    $scope.consignee_address_countries = angular.copy(window.countries);
    $scope.notify_address_countries = angular.copy(window.countries);
    $scope.docs_address_countries = angular.copy(window.countries);
    $scope.bank_countries = angular.copy(window.countries);
    $scope.buyer = !_.isEmpty(window.buyer_details) ? window.buyer_details : $scope.get_buyer_details();
    $scope.$emit('publish_data', $scope.buyer);
  }
}

BuyerAddresses.$inject = ['$scope', 'GeoService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/buyer-addresses.ctrl.js